import { render, staticRenderFns } from "./panel2.vue?vue&type=template&id=cb045278&scoped=true"
import script from "./panel2.vue?vue&type=script&lang=js"
export * from "./panel2.vue?vue&type=script&lang=js"
import style0 from "./panel2.vue?vue&type=style&index=0&id=cb045278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb045278",
  null
  
)

export default component.exports